module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-4-tablet-cfaeb63023cd7ad38703a2502d13ab5e.png";